module.exports = __webpack_public_path__ + "static/drawing-9450615d26c50e913b8e7b74657e84b8.jpg";